<template>
  <transition @enter="onEnter" @leave="onLeave" :css="false">
    <div v-cloak v-if="sharedState.activeOverlay === $options.name" class="menu-overlay pt5">
      <nav>
        <div class="grid cf">
          <div class="col-l col-9-l push-1-l pt3">
            <ul class="menu__list list relative z-5 f1 color-2 mb6-l">
              <li v-for="(page, i) in pages" :key="i" class="list__item mb4 pb1" data-menu-item>
                <a
                  :href="page.url"
                  :class="page.active"
                  :target="page.blank ? '_blank' : '_self'"
                >{{ page.name }}</a>
              </li>
            </ul>
          </div>

          <!-- <div class="col-l col-1-l">
            <a href="/" class="light fw5 tr">- Home</a>
          </div>-->
        </div>
      </nav>

      <button-circle-rotating
        v-cloak
        v-if="sharedState.activeOverlay === $options.name && sharedState.isCommerceInstalled"
        :shop="this.webshop"
        :darkTheme="currentLocation == 'portal' || lobbyLocation || currentLocation == 'shop' ? 'dark' : 'light'"
      ></button-circle-rotating>
    </div>
  </transition>
</template>

<script>
import s from "../store"
import { handleMenuOverlayEnter, handleMenuOverlayLeave } from "./MenuOverlay"
import ButtonCircleRotating from "./ButtonCircleRotating.vue"

export default {
  name: "PageNav",

  components: {
    ButtonCircleRotating
  },

  props: {
    currentLocation: String,
    lobbyLocation: Boolean,
    pages: Array,
    webshop: Object
  },

  data() {
    return {
      activeItem: null,
      sharedState: s.state
    }
  },

  methods: {
    onEnter: function(el, done) {
      handleMenuOverlayEnter(el, done)
    },

    onLeave: function(el, done) {
      this.setActive(null)
      handleMenuOverlayLeave(el, done)
    },

    setActive: function(item) {
      this.activeItem = this.activeItem === item ? null : item
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
